<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Save as Template</p>
        <button class="delete" v-on:click="hideModal"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="preSubmit">
          <div class="field">
            <label class="label">Title</label>
            <div class="control has-icons-right mt-2">
              <input
                type="text"
                :class="['input', { 'is-danger': errors['title'] }]"
                v-model="title"
                name="title"
                required
              />
              <span class="icon is-small is-right" v-if="errors['title']"
                ><i class="fa fa-warning"></i
              ></span>
            </div>
            <p v-if="errors['title']" class="help is-danger">
              {{ errors["title"] }}
            </p>
          </div>

          <div class="field">
            <label class="label">Body</label>
            <p v-html="body"></p>
          </div>

          <button
            :class="[
              'button',
              'is-primary',
              'is-large',
              'is-pulled-right',
              { 'is-loading': working }
            ]"
          >
            Save
          </button>
        </form>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" v-on:click="hideModal">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "care-template-save-modal",

  props: ["show", "body", "hide", "onSubmit", "working"],

  data() {
    return {
      title: "",
      errors: {}
    };
  },

  methods: {
    hideModal() {
      this.$props.hide();
    },
    preSubmit() {
      this.onSubmit(this.title);
    }
  }
};
</script>

<style lang="scss" scoped></style>
